export default __webpack_public_path__ + "static/media/logo-carlos-okellys.9f5c7fd4.png";